import React, { useEffect, useState } from 'react';
import styles from '../index.module.css'
import SolicitationService from '../../../../services/SolicitationService/SolicitationService';
import LcAccordion from '../../../../components/Generic/LcAccordion';
import LcIcon from '../../../../components/Generic/LcIcon';
import moment from 'moment';
import LcLoading from '../../../../components/Generic/LcLoading';
import { SolicitationView } from '../../../../models/SolicitationView';
import LcTooltip from '../../../../components/Generic/LcTooltip';

interface SLA {
    idSla: number,
    idSlaTime: number,
    description: string,
    responseTime: number,
    responseDate: string | Date,
    responseStatus: number,
    responseColor: string,
    responseWarning1: string | Date,
    responseWarning2: string | Date,
    solutionTime: number,
    solutionDate: string | Date,
    solutionStatus: number,
    solutionColor: string,
    solutionWarning1: string | Date,
    solutionWarning2: string | Date,
    id: number
}

interface Props {
    solicitation: SolicitationView,
}

const SolicitationSlaSlo: React.FC<Props> = (props) => {

    const [solicitationService, setSolicitationService] = useState<SolicitationService>(new SolicitationService(props));

    const [slaInfo, setSlaInfo] = useState<SLA>()
    const [remainingTime, setRemainingTime] = useState<string>('');
    const [responseDate, setResponseDate] = useState<string>('');
    const [slaResponseDate, setSlaResponseDate] = useState<string>('');
    const [remainingResponse, setRemainingResponse] = useState<string>('');
    const [remainingResponseSDate, setRemainingResponseSDate] = useState<string>('');
    const [remainingSLA, setRemainingSLA] = useState<string>('');
    const [slaSolutionDateDefault, setSlaSolutionDateDefault] = useState<string>('');
    const [slaSolutionDate, setSlaSolutionDate] = useState<string>('');
    const [slaSolDate, setSlaSolDate] = useState<string>('');
    const [greaterThanVerdSol, setGreaterThanVerdSol] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.solicitation) {
            getSla();
        }
    }, [props.solicitation])

    useEffect(() => {
        if (slaInfo) {
            //  setRemainingTime(0);

            var respon = (props.solicitation.responseDate) ? moment(props.solicitation.responseDate).format("DD/MM/YYYY HH:mm") : '';
            var slaErespon = (slaInfo.responseDate) ? moment(slaInfo.responseDate).format("DD/MM/YYYY HH:mm") : '';
            setResponseDate(respon);
            setSlaResponseDate(slaErespon);

            var slacloseDate = moment(new Date());

            if (props.solicitation.endDate) slacloseDate = moment(props.solicitation.endDate);
            if (props.solicitation.cancellationDate) slacloseDate = moment(props.solicitation.cancellationDate);

            var slaResponDate = moment(new Date());

            if (props.solicitation.responseDate) {
                slaResponDate = moment(props.solicitation.responseDate);

                if (props.solicitation.responseDate == null && props.solicitation.endDate) slaResponDate = moment(props.solicitation.endDate);
                if (props.solicitation.responseDate == null && props.solicitation.cancellationDate) slaResponDate = moment(props.solicitation.cancellationDate);
            }

            // setRemainingTime(dataDiferenca);
            var dataSLACLOSEANUumber = moment(slaInfo.solutionDate).diff(slacloseDate);
            var dataSLACLOSEAA = moment(slacloseDate).from(slaInfo.solutionDate).replace('há', '').replace('em', '');

            var dataSLAResponseANUumber = moment(slaInfo.responseDate).diff(slaResponDate);
            var dataSLAResponseAA = moment(slaResponDate).from(slaInfo.responseDate).replace('há', '').replace('em', '');

            setSlaSolDate(moment(slaResponDate).format("DD/MM/YYYY HH:mm"));

            var slaSolutionDate_ = moment(slaInfo.solutionDate);
            if (props.solicitation.endDate) slaSolutionDate_ = moment(props.solicitation.endDate);
            if (props.solicitation.cancellationDate) slaSolutionDate_ = moment(props.solicitation.cancellationDate);

            setSlaSolutionDateDefault(moment(slaInfo.solutionDate).format("DD/MM/YYYY HH:mm"));
            setSlaSolutionDate(slaSolutionDate_.format("DD/MM/YYYY HH:mm"));

            var labelSLACLOSEA = (dataSLACLOSEANUumber > 0) ? "restam ainda" : "excedeu em";

            if (props.solicitation.endDate || props.solicitation.cancellationDate) {
                labelSLACLOSEA = (dataSLACLOSEANUumber > 0) ? "restariam ainda" : "excedeu em";
            }

            labelSLACLOSEA += ` ${dataSLACLOSEAA}`;
            setRemainingSLA(labelSLACLOSEA);


            var labelSLAResponseAA = (dataSLAResponseANUumber > 0) ? "restam ainda" : "excedeu em";

            if (props.solicitation.endDate || props.solicitation.cancellationDate) {
                labelSLAResponseAA = (dataSLAResponseANUumber > 0) ? "restariam ainda" : "excedeu em";
            }

            labelSLAResponseAA += ` ${dataSLAResponseAA}`;
            setRemainingResponse(labelSLAResponseAA);
        }
    }, [slaInfo])

    const getSla = async () => {
        setSlaInfo(undefined);
        setLoading(true);

        try {
            const solicitationResponse = await solicitationService.GetSLA(props.solicitation.id)
            setSlaInfo(solicitationResponse.data);
        }
        catch (error) {
            console.warn(error);
        }

        setLoading(false);
    }

    return (
        <div style={{ marginTop: "20px" }}>
            <LcAccordion title='SLA / SLO' visible iconNormal>
                <LcLoading label='carregando...' loading={loading}>
                    <span style={{ padding: '1rem 0px', }} className={styles.slaName}>
                        <p><b>{slaInfo?.description}</b></p>
                        <div style={{ marginLeft: "30px" }}>
                            {/* <LcIcon icon='ppi ppi-external-link' color={"#0580CE"} /> */}
                        </div>
                    </span>

                    <span className={styles.sla}>
                        <span className={styles.title}> Resposta </span>
                        <span className={styles.slaInformation}>
                            <div style={{ width: '48%' }}>
                                <LcTooltip trigger='hover' content={
                                    <p>
                                        {(props.solicitation.responseDate ? "Esperado em " : "Esperado em ")} <strong> {slaResponseDate}</strong>
                                        {props.solicitation.responseDate ? " e concluído em " : ''}<strong>{props.solicitation.responseDate ? responseDate : ''}</strong>
                                    </p>
                                }>
                                    <span> {(props.solicitation.responseDate ? "Esperado em " : "Esperado em ")} <strong>{slaResponseDate}</strong> e <strong>{`${remainingResponse}`}</strong> </span>
                                </LcTooltip>
                            </div>

                            <div style={{ width: '50%', display: 'flex', flexDirection: 'row', alignItems: 'baseline', justifyContent: 'flex-start' }}>
                                <p style={{ width: '75px', display: 'flex', justifyContent: 'flex-end', paddingRight: '1rem', color: props.solicitation.slaCor, fontWeight: "700" }}>{props.solicitation.slaPercentual}%</p>

                                <div style={{ width: "200px", height: "10px", backgroundColor: "#BDBDBD", borderRadius: "10px" }}> {/* barra */}
                                    <div style={{ width: `${props.solicitation.slaPercentual}%`, height: "10px", backgroundColor: props.solicitation.slaCor, borderRadius: "10px" }} /> {/* cor da barra */}
                                </div>
                            </div>
                        </span>
                    </span>

                    <span className={styles.slo}>
                        <span className={styles.title}> Solução </span>
                        <span className={styles.sloInformation}>
                            <div style={{ width: '48%' }}>
                                <LcTooltip trigger='hover' content={
                                    <p>
                                        {(props.solicitation.endDate || props.solicitation.cancellationDate ? "Esperado em " : "Esperado em ")} <strong> {slaSolutionDateDefault}</strong>
                                        {props.solicitation.endDate || props.solicitation.cancellationDate ? " e concluído em " : ''}<strong>{props.solicitation.endDate || props.solicitation.cancellationDate ? slaSolutionDate : ''}</strong>
                                    </p>
                                }>
                                    <span>  {(props.solicitation.endDate || props.solicitation.cancellationDate ? "Esperado em " : "Esperado em ")} <strong>{slaSolutionDateDefault}</strong> e <strong>{`${remainingSLA}`} </strong></span>
                                </LcTooltip>
                            </div>
                            <div style={{ width: '50%', display: 'flex', flexDirection: 'row', alignItems: 'baseline', justifyContent: 'flex-start' }}>
                                <p style={{ width: '75px', display: 'flex', justifyContent: 'flex-end', paddingRight: '1rem', color: props.solicitation.sloCor, fontWeight: "700" }}> {props.solicitation.sloPercentual}%</p>

                                <div style={{ width: "200px", height: "10px", backgroundColor: "#BDBDBD", borderRadius: "10px" }}> {/* barra */}
                                    <div style={{ width: `${props.solicitation.sloPercentual}%`, height: "10px", backgroundColor: props.solicitation.sloCor, borderRadius: "10px" }} /> {/* cor da barra */}
                                </div>
                            </div>
                        </span>
                    </span>
                </LcLoading>
            </LcAccordion>
        </div>
    );
};

export default SolicitationSlaSlo;